module.exports = __webpack_public_path__ + "img/MGH-Gion-6.45fe31e9.jpg";